import { Route, Routes } from 'react-router-dom';
import { Layout } from '~/components/Layout';

import useTestingRoute from '../hooks/useTestingRoute';

import NavigateToTestingRoute from './NavigateToTestingRoute';
import type { TestingRouteProps } from '../types';

const TESTING_ROUTE_PREFIX_PATH = 'testing/*';

const TestingRoute = ({
  TestingApplication,
  testingRoute,
  graphqlEndpoint,
  collectorUrl,
  enableRedux,
  enableDatadog,
  isProtected,
  layout,
  environmentOptions,
}: TestingRouteProps) => {
  const { path, element } = useTestingRoute({
    TestingApplication,
    testingRoute,
    isProtected,
    graphqlEndpoint,
    collectorUrl,
    enableRedux,
    enableDatadog,
    environmentOptions,
  });

  return (
    <Layout hideLayout={() => layout === false}>
      <Routes>
        <Route path={path} element={element} />
        <Route path="*" element={<NavigateToTestingRoute path={path} />} />
      </Routes>
    </Layout>
  );
};

export { TESTING_ROUTE_PREFIX_PATH, TestingRoute };

export type { TestingRouteProps };
